import { render, staticRenderFns } from "./SportsModuleCard.vue?vue&type=template&id=c375c24e&scoped=true"
import script from "./SportsModuleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsModuleCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsModuleCard.vue?vue&type=style&index=0&id=c375c24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c375c24e",
  null
  
)

export default component.exports